import { DataBean } from "../../DataBean";


export class PersonPhoto extends DataBean {

    public async getPersonPhoto(acc: any): Promise<any> {
        return this.getCustomService("OrangeBase", "java.util.List_getPersonPhoto_Number", [acc]);
    }
 public async addPersonPhoto(acc: any,viewType:any,sideType:any,media:any,context:any,dataStore:any): Promise<any> {
        return this.getCustomService("OrangeBase", "com.orange.bean.account.PersonPhoto_addPersonPhoto_Number_Number_Number_String_String_String", [acc,viewType,sideType,media,context,dataStore]);
    }

    public async deleteBioIdentity(idBioIdentity: any): Promise<any> {
        return this.getCustomService("OrangeBase", "void_deleteBioIdentity_Number", [idBioIdentity]);
    }
}